import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { head, set } from "lodash";
import(/* webpackChunkName: "order-builder-ite-presets" */ "./itepresets.scss");
import InsertLink from "@material-ui/icons/InsertLink";
import LinkOff from "@material-ui/icons/LinkOff";
import testModel from "../../../../assets/img/ModelTest.png";

const ITEPresets = ({
  rightSelected,
  leftSelected,
  itePowerLevelRight,
  itePowerLevelLeft,
  iteModelLinked,
  presets,
  selectedPresetRight,
  setSelectedPresetRight,
  selectedPresetLeft,
  setSelectedPresetLeft,
}) => {
  const [linked, setLinked] = useState(true);

  useEffect(() => {
    // Right ear defaults to manual if right is selected and nothing chosen yet
    if (rightSelected && !selectedPresetRight && presets && presets.length > 0) {
      console.log("setting to manual 1");
      setSelectedPresetRight("manual");
    }

    // Left ear defaults to manual if left is selected and nothing chosen yet
    if (leftSelected && !selectedPresetLeft && presets && presets.length > 0) {
      setSelectedPresetLeft("manual");
    }

    // If linked, mirror behaviour
    if (linked && iteModelLinked) {
      if (rightSelected && !selectedPresetLeft) {
        setSelectedPresetLeft("manual");
      }
      if (leftSelected && !selectedPresetRight) {
      console.log("setting to manual 2");
        setSelectedPresetRight("manual");
      }
    }
  }, [
    rightSelected,
    leftSelected,
    iteModelLinked,
    linked,
    selectedPresetRight,
    selectedPresetLeft,
    setSelectedPresetRight,
    setSelectedPresetLeft,
  ]);

  // Set preset for order
  // Set other side if still linked
  const setRightActive = (preset) => {
      console.log("setting to preset 1");
    setSelectedPresetRight(preset);
    if (linked && iteModelLinked) {
      setSelectedPresetLeft(preset);
    }
  };

  const setLeftActive = (preset) => {
    setSelectedPresetLeft(preset);
    if (linked && iteModelLinked) {
      console.log("setting to preset 2");
      setSelectedPresetRight(preset);
    }
  };

  return (
    <div>
      {(itePowerLevelRight || itePowerLevelLeft) &&
        (rightSelected || leftSelected) && (
          <div className="ite-preset-component-main-div order-builder-component">
            <Row className="order-builder-component-title">
              <Col xs={4}>
                <h2>Choose a preset</h2>
              </Col>
              <Col xs={8}>
                <Row>
                  {/* Ear headings + link icon row (copied structure from ITEPowerLevel) */}
                  <Col md={5}>
                    {rightSelected && (
                      <div className="text-right">
                        <h3>Right Ear</h3>
                      </div>
                    )}
                  </Col>

                  <Col md={2}>
                    {rightSelected && leftSelected && (
                      <div className="text-center link-div">
                        {linked ? (
                          <InsertLink
                            className="linked"
                            onClick={() => setLinked(false)}
                          />
                        ) : (
                          <LinkOff
                            className="unlinked"
                            onClick={() => setLinked(true)}
                          />
                        )}
                      </div>
                    )}
                  </Col>

                  <Col md={5}>
                    {leftSelected && (
                      <div>
                        <h3>Left Ear</h3>
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    {rightSelected && (
                      <Row className="ite-power-level-row-right">
                        {presets &&
                          presets.map((preset, index) => (
                            <Col key={index} xs={4}>
                              <a
                                onClick={() => {
                                  setRightActive(preset);
                                }}
                              >
                                <div
                                  className={`ite-preset-box ${
                                    selectedPresetRight &&
                                    selectedPresetRight.Code === preset.Code
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <div className="ite-preset-box-text">
                                    <p>{preset.Name}</p>
                                  </div>
                                </div>
                              </a>
                            </Col>
                          ))}
                        <Col key={"manual"} xs={4}>
                          <a
                            onClick={() => {
                              setRightActive("manual");
                            }}
                          >
                            <div
                              className={`ite-preset-box ${
                                selectedPresetRight &&
                                selectedPresetRight === "manual"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              <div className="ite-preset-box-text">
                                <p>Manual</p>
                              </div>
                            </div>
                          </a>
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col md={6}>
                    {leftSelected && (
                      <Row className="ite-power-level-row-left left-side">
                        {presets &&
                          presets.map((preset, index) => (
                            <Col key={`left-${index}`} xs={4}>
                              <a
                                onClick={() => {
                                  setLeftActive(preset);
                                }}
                              >
                                <div
                                  className={`ite-preset-box ${
                                    selectedPresetLeft &&
                                    selectedPresetLeft.Code === preset.Code
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <div className="ite-preset-box-text">
                                    <p>{preset.Name}</p>
                                  </div>
                                </div>
                              </a>
                            </Col>
                          ))}

                        {/* Manual option – left side */}
                        <Col key="left-manual" xs={4}>
                          <a
                            onClick={() => {
                              setLeftActive("manual");
                            }}
                          >
                            <div
                              className={`ite-preset-box ${
                                selectedPresetLeft &&
                                selectedPresetLeft === "manual"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              <div className="ite-preset-box-text">
                                <p>Manual</p>
                              </div>
                            </div>
                          </a>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
    </div>
  );
};

export default ITEPresets;
